<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import ImportStudents from "./import-students.vue";
import VyukaForm from "@/components/ll/vyuka-form.vue";
import LessonInstance from "@/components/ll/lesson-instance.vue";
import AdminCreditHistoryModal from "./admin-credit-history-modal.vue";

export default {
  name: "my_students",
  props: ['btyp', 'admin'],
  components: {LessonInstance, VyukaForm, ImportStudents, AdminCreditHistoryModal },
  data() {
    return {
      lessons: [],
      companies:[],
      current_lesson: null,
      lector_options: [],
      selectedCompany: null,
      selectedLector: null,
      selectedTypeLesson: null,
      credit_range: '',
      searchQuery: '',
      searchGroupName: '',
      searchDebounceTimer: null
    };
  },
  mounted() {
    this.loadStudents();
  },
  methods: {
    handleEditLesson(lesson) {
        this.current_lesson = lesson;
        // Předpokládáme, že máte komponentu pro úpravu lekce
        // Můžete zde otevřít modální okno nebo přesměrovat
      this.$refs.formVyuka.showModal();

    },
    handleNewLessonInstance(lesson) {
      // Kontrola accounting limits podle typu systému
      if (lesson.accounting_type === 'credit_based' && lesson.credit <= 0) {
        toast.error("Student has no credit!");
        return;
      }
      
      if (lesson.accounting_type === 'lessons_per_month') {
        const currentCount = lesson.instances_count_this_month || 0;
        if (currentCount >= lesson.lessons_per_month) {
          toast.error(`This month's lesson limit has been exceeded (${currentCount}/${lesson.lessons_per_month})`);
          return;
        }
      }
      
      // Pro flexible - vždy povolit
      this.current_lesson = lesson;
      this.$refs.formLessonInstance.showModal();

    },


    loadStudents() {
      const url = '/ll/students/lessons.json';
      axios.get(url, {
        params: {
          btyp: this.btyp,
          company_id: this.selectedCompany,
          lector_id: this.selectedLector,
          lesson_type: this.selectedTypeLesson,
          credit_range: this.credit_range,
          search_query: this.searchQuery,
          group_name: this.searchGroupName
        }
      })
          .then(response => {
            this.lessons = response.data.lessons;
            this.companies = response.data.companies;
            this.lector_options = response.data.lectors;
          })
          .catch(error => {
            console.error('Došlo k chybě při načítání lekcí:', error);
          });
    },
    handleSearchInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.loadStudents();
      }, 500);
    },
    handleGroupNameInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.loadStudents();
      }, 500);
    },
    handleImportSuccess() {
      this.loadStudents();
    },
    showImportModal() {
      this.$refs.importStudentsComponent.showModal();
    },
    addVyuka() {
      this.current_lesson = {
        students: [],
        lector: null,
        lesson_type: 'one_to_one',
        language_level: '',
        preferred_time: '',
        minutes: 0,
        lessons_per_month: 0,
        credit: 0,
        change_credit:0
      };
      this.$refs.formVyuka.showModal();
    },
    handleSaveLesson(lesson) {
      this.loadStudents();
    },
    showCreditHistory(lesson) {
      this.$refs.creditHistoryModal.open(lesson.id);
    }
  }
}
</script>

<template>
  <div>
    <h1>{{btyp=='b2b' ? "B2B firemní studenti": "Samostatní studenti B2C" }}</h1>


    <div class="d-flex justify-content-end " style="position:absolute; top:5px; right:0; height:30px;" v-if="admin">
      <button type="button" class="btn btn-primary" @click="showImportModal" v-if="btyp=='b2b'">
        Importovat studenty
      </button>
      <button type="button" class="btn btn-primary" @click="addVyuka">
       Přidat výuku
      </button>
    </div>

    <import-students ref="importStudentsComponent" @import-successful="handleImportSuccess"></import-students>
  </div>

  <div class=" card card-body  mt-2">
    <div class="row">
      <div class="col-md-3" >
        <label>Vyhledat studenta (e-mail nebo jméno)</label>
        <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          @input="handleSearchInput"
          placeholder="Zadejte e-mail nebo jméno studenta"
        >
      </div>

      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Společnost</label>
        <select v-model="selectedCompany" class="form-control" @change="loadStudents">
          <option value="">-- Vyberte společnost --</option>
          <option v-for="company in companies" :key="company.id" :value="company.id">
            {{ company.name }}
          </option>
        </select>



      </div>

      <div class="col-md-3" v-if="admin">
        <label>Lektor</label>
        <select v-model="selectedLector" class="form-control" @change="loadStudents">
          <option value="">-- Vyberte lektora --</option>
          <option v-for="lector in lector_options" :key="lector.id" :value="lector.id">
            {{ lector.first_name }} {{ lector.last_name }}
          </option>

        </select>

      </div>

      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Typ lekce</label>
        <select class="form-control" @change="loadStudents" v-model="selectedTypeLesson">
          <option></option>
          <option value="one_to_one">jeden na jednoho</option>
          <option value="two_students"> párová lekce</option>
          <option value="group">skupinová lekce</option>

        </select>

      </div>

      <div class="col-md-3" v-if="btyp==='b2c'">
        <label>Kredit</label>
        <select v-model="credit_range" @change="loadStudents" class="form-control">
          <option value="">Všechny</option>
          <option value="less_than_4">Méně než 4 lekce</option>
          <option value="more_than_4">Více než 4 lekce</option>
          <option value="no_credit">Žádný kredit</option>
        </select>
      </div>

    </div>

    <!-- New row for Group Name filter -->
    <div class="row mt-2">
      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Název skupiny</label>
        <input
          type="text"
          class="form-control"
          v-model="searchGroupName"
          @input="handleGroupNameInput"
          placeholder=""
        />
      </div>
    </div>








    <table class="table table-bordered mt-2">

      <thead>
      <tr>
        <th>Student/s</th>
        <th v-if="btyp === 'b2b'">Company</th>
        <th>Lecturer</th>
        <th>Types of lessons</th>
        <th>Language</th>
        <th>Language level</th>
        <th>Preferred time</th>
        <th>How many minutes</th>
        <th v-if="btyp === 'b2b'">Systém účtování</th>
        <th v-if="btyp === 'b2b'">Lesson number</th>
        <th>Credit</th>
        <th colspan="2">Akce</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="lesson in lessons" :key="lesson.id">
        <td>
          <ul class="list-unstyled mb-0">
            <li v-for="student in lesson.students" :key="student.id">
              <i>{{ student.email }}</i> <a :href="`/students/${student.id}`" target="_blank">{{student.name}} {{student.surname}}</a>
            </li>
          </ul>
        </td>
        <td v-if="btyp === 'b2b'">{{ lesson.organization?.name || 'N/A' }}</td>
        <td>{{ lesson.lector ? [lesson.lector.first_name, lesson.lector.last_name].join(' ')  : 'N/A' }}</td>
        <td>{{ lesson.lesson_type_name }}</td>
        <td>{{ lesson.language ? lesson.language.iso_code : 'N/A' }}</td>
        <td>{{ lesson.language_level }}</td>
        <td>{{ lesson.preferred_time_name }}</td>
        <td>{{ lesson.minutes }}</td>
        
        <!-- Systém účtování - POUZE B2B -->
        <td v-if="btyp === 'b2b'">
          <span v-if="lesson.accounting_type === 'flexible'" class="badge badge-info">
            <i class="fas fa-infinity"></i> Flexible
          </span>
          <span v-else-if="lesson.accounting_type === 'lessons_per_month'" class="badge badge-warning">
            <i class="fas fa-calendar-check"></i> Měsíční limit
          </span>
          <span v-else-if="lesson.accounting_type === 'credit_based'" class="badge badge-success">
            <i class="fas fa-coins"></i> Kredit
          </span>
        </td>
        
        <!-- Lesson number - zobrazit JEN pro lessons_per_month v B2B -->
        <td v-if="btyp === 'b2b'">
          <span v-if="lesson.accounting_type === 'lessons_per_month'">
            {{ lesson.instances_count_this_month || 0 }} / {{ lesson.lessons_per_month }}
          </span>
          <span v-else class="text-muted">-</span>
        </td>
        
        <!-- Credit - zobrazit vždy, ale jen aktivní pro credit_based -->
        <td>
          <template v-if="lesson.accounting_type === 'credit_based' || btyp === 'b2c'">
            {{lesson.instances_count}} /
            <a href="#" 
               @click.prevent="showCreditHistory(lesson)" 
               class="credit-link"
               title="Zobrazit historii kreditů">
              {{lesson.credit}}
            </a>
          </template>
          <span v-else class="text-muted">-</span>
        </td>
        <td>
          <a v-if="admin" href="#" @click.prevent="handleEditLesson(lesson)">upravit</a>
        </td>
        <td>
          <a href="#" @click.prevent="handleNewLessonInstance(lesson)">New lesson </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <vyuka-form :lesson="current_lesson" :btyp="btyp"  ref="formVyuka" @save-lesson="handleSaveLesson"></vyuka-form>

 <lesson-instance :lesson="current_lesson" ref="formLessonInstance" :admin="admin"></lesson-instance>

 <admin-credit-history-modal ref="creditHistoryModal" />

</template>

<style scoped>
.credit-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  transition: all 0.2s ease;
}

.credit-link:hover {
  color: #0056b3;
  background-color: #e7f3ff;
  text-decoration: underline;
}
</style>